import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import CardContent from "@mui/joy/CardContent";
import Card from "@mui/joy/Card";

// components
import KpiCard from "./KpiCard";
import BaseApi from "../../utils/BaseApi";
import {getWeekNumber} from "../../utils/misc";


class KpiMyList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            report: [],
        };
        switch (this.props.kpi.aggregation_period) {
            case 'MONTH':
                this.activeCard = new Date().getMonth();
                break
            case 'WEEK':
                this.activeCard = getWeekNumber(new Date());
                break
            default:
                this.activeCard = 0;
                break
        }
    }

    async componentDidMount() {
        await this.retrieveReport();
    }

    async retrieveReport() {
        const url = 'kpi/report/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                subscriber: this.props.subscriber,
                kpi: this.props.kpi.id,
            }
        );
        this.setState(
            {
                report: response.data
            }
        );
    }

    render() {
        if (!this.state.report) {
            return (<CircularProgress/>)
        }
        return (
            <>
                <Typography
                    level={'h3'}
                >
                    {this.props.kpi.title}
                </Typography>
                <Stack
                    direction={'row'}
                >
                    <Card
                        variant="soft"
                        invertedColors
                        sx={{
                            mx: 1,
                        }}
                        size={'sm'}
                    >
                        <CardContent
                            orientation="vertical"
                        >
                            <Typography
                                level="body-sm"
                            >
                                Период
                            </Typography>
                            <Typography
                                level="body-lg"
                            >
                                Значение
                            </Typography>
                            <Typography
                                level="body-sm"
                            >
                                П+нП
                            </Typography>
                            <Typography
                                level="body-sm"
                            >
                                Цель
                            </Typography>
                            <Typography
                                level="body-sm"
                            >
                                Разница
                            </Typography>
                            <Typography
                                level="body-sm"
                            >
                                Доля
                            </Typography>
                        </CardContent>
                    </Card>
                    <Box
                        sx={{
                            display: 'flex',
                            flexGrow: 20,
                            overflow: 'hidden',
                        }}
                    >
                        <Swiper
                            style={{
                                minWidth: '100%'
                            }}
                            // modules={[Navigation, Pagination]}
                            spaceBetween={0}
                            //navigation
                            // pagination={{
                            //     clickable: true
                            // }}
                            onSwiper={(swiper) => swiper.slideTo(this.activeCard>0?this.activeCard-1:this.activeCard)}
                            breakpoints={{
                                1550: {
                                    slidesPerView: 8
                                },
                                1180: {
                                    slidesPerView: 6
                                },
                                1020: {
                                    slidesPerView: 6
                                },
                                700: {
                                    slidesPerView: 3
                                }
                            }}
                        >
                            {this.state.report.map((row) => {
                                return (
                                    <SwiperSlide
                                        key={`${this.props.kpi.id}-${row.period}`}
                                    >
                                        <KpiCard
                                            kpi={row}
                                            activeCard={this.activeCard}
                                        />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </Box>

                </Stack>
            </>
        )
    }
}

export default KpiMyList